@if (!data) {
    <div
        [class]="{
            'details-title': title,
            'justify-content-end': !title,
            'list-tools': readonly || !isEmbedded,
        }"
    >
        @if (title) {
            <h4>{{ title }}</h4>
        }
        <!-- @else {
    <it-checkbox [(ngModel)]="items.allBarriersChecked" [indeterminate]="indeterminate">
        @if (items.checkedBarriers.length) {
        <ng-container label>
            {{ selectedTranslationKey | translate : { numSelected: items.checkedBarriers.length } }}
        </ng-container>
        }
    </it-checkbox>
    }  -->
        @if (pagination && pagination.totaleElementi > 1) {
            <div class="d-inline-flex">
                @if (!title) {
                    <a
                        (click)="download('PDF')"
                        [ariaDisabled]="toolsDisabled"
                        [attr.aria-label]="'it.portal.print' | translate"
                    >
                        <span class="material-symbols-outlined icon-tool me-1"> print </span>
                        <span>{{ "it.portal.print" | translate }}</span>
                    </a>
                    <a
                        (click)="download('XLSX')"
                        class="ms-5"
                        [ariaDisabled]="toolsDisabled"
                        [attr.aria-label]="'it.general.download' | translate"
                    >
                        <span class="material-symbols-outlined icon-tool me-1"> download </span>
                        <span>{{ "it.general.download" | translate }}</span>
                    </a>
                }
                <it-dropdown class="ms-5">
                    <span button
                        >{{ "it.portal.sort" | translate }}
                        {{ sortTranslationKey(searchFilters.ordinamento) | translate }}</span
                    >
                    <ng-container list>
                        @for (item of sortList; track $index) {
                            <it-dropdown-item (click)="onSortOptionChange(item)">{{
                                sortTranslationKey(item) | translate
                            }}</it-dropdown-item>
                        }
                    </ng-container>
                </it-dropdown>
            </div>
        }
    </div>
}
<it-list class="custom-list">
    @for (item of items.risultati; track item.uid) {
        <it-list-item iconLeft="true" class="list-data" [active]="item.checked">
            <!-- @if(!isEmbedded){<it-checkbox [(ngModel)]="item.checked"></it-checkbox>} -->
            <div class="flex-grow-1">
                <div class="list-title">
                    @if (!isCurrentVersion(item.uid) && !isPublic) {
                        <a (click)="openBarrier(item.uid)" class="text me-4">{{ item.denominazione }}</a>
                    } @else {
                        <div class="text me-4">
                            {{ item.denominazione }}
                        </div>
                    }
                    @if (!isPublic) {
                        <it-chip
                            [label]="'v' + item.numeroVersione"
                            class="chip-version me-2"
                            [class]="{ active: isCurrentVersion(item.uid) }"
                        ></it-chip>
                    }
                </div>
                <div class="list-info d-block">
                    <div class="row">
                        <div class="col-lg-3">
                            {{ "it.portal.municipality-of" | translate }}
                            {{ item.comune | municipalityName: isPublic | async }}
                        </div>
                        @if (item.localita) {
                            <div class="col-lg-3">{{ "it.portal.locality" | translate }}: {{ item.localita }}</div>
                        }
                        @if (item.indirizzo) {
                            <div class="col-lg-3">{{ item.indirizzo }}</div>
                        }
                        @if (isEmbedded) {
                            @if (item.destinazioniUso && item.destinazioniUso.length) {
                                <div class="col-lg-4">
                                    {{ "it.portal.barriers.purpose" | translate }}:
                                    @for (id of item.destinazioniUso; track id; let last = $last) {
                                        <span>{{ id | purposeName: isPublic | async }}{{ last ? "" : ", " }}</span>
                                    }
                                </div>
                            }
                            @if (item.categoria) {
                                <div class="col-lg-4">
                                    {{ "it.portal.barriers.category" | translate }}: {{ item.categoria }}
                                </div>
                            }
                            @if (item.tipologia) {
                                <div class="col-lg-4">
                                    {{ "it.portal.barriers.tipology" | translate }}: {{ item.tipologia }}
                                </div>
                            }
                        }
                        <div class="col-lg-3 text-lg-end">
                            {{ "it.portal.barriers.update" | translate }}
                            {{ item.aggiornamento | date: "dd/MM/yy" }}
                        </div>
                    </div>
                </div>
            </div>
            <ng-container multiple>
                <div class="actions">
                    @if (!isCurrentVersion(item.uid)) {
                        <a
                            (click)="openBarrier(item.uid)"
                            [attr.aria-label]="'it.portal.barriers.open' | translate"
                            [itTooltip]="'it.portal.barriers.open' | translate"
                            [tooltipPlacement]="TooltipPlacement"
                        >
                            <span class="material-symbols-outlined"> home </span>
                        </a>
                    }
                    @if (authService.hasAllQualifications([QualificationType.MANAGE_BARRIERS]) | async) {
                        @if (!isEmbedded) {
                            @if (item.fascicolo) {
                                <a
                                    (click)="openFolder(item.fascicolo)"
                                    [attr.aria-label]="'it.portal.folders.open' | translate"
                                    [itTooltip]="'it.portal.folders.open' | translate"
                                    [tooltipPlacement]="TooltipPlacement"
                                >
                                    <span class="material-symbols-outlined"> folder_open </span>
                                </a>
                            } @else if (item.ultimaVersione) {
                                <a
                                    (click)="createFolder(item.uid)"
                                    [attr.aria-label]="'it.portal.folders.create' | translate"
                                    [itTooltip]="'it.portal.folders.create' | translate"
                                    [tooltipPlacement]="TooltipPlacement"
                                >
                                    <span class="material-symbols-outlined"> create_new_folder </span>
                                </a>
                                <a
                                    (click)="createVersion(item)"
                                    [attr.aria-label]="'it.portal.barriers.version.create' | translate"
                                    [itTooltip]="'it.portal.barriers.version.create' | translate"
                                    [tooltipPlacement]="TooltipPlacement"
                                >
                                    <span class="material-symbols-outlined"> new_label </span>
                                </a>
                                <a
                                    (click)="deleteBarrier(item.uid)"
                                    [attr.aria-label]="'it.portal.barriers.remove' | translate"
                                    [itTooltip]="'it.portal.barriers.remove' | translate"
                                    [tooltipPlacement]="TooltipPlacement"
                                >
                                    <span class="material-icons-outlined">delete</span>
                                </a>
                            }
                        }
                    }
                </div>
            </ng-container>
        </it-list-item>
    } @empty {
        <div class="text" [class]="title ? 'py-3' : 'p-3'">{{ "it.portal.no-results" | translate }}</div>
    }
</it-list>
@if (pagination && pagination.totaleElementi > 10) {
    <div class="mt-5">
        <it-pagination
            [currentPage]="pagination.numeroPagina"
            [pageNumbers]="pagination.totalePagine"
            [currentChanger]="pagination.elementiPagina"
            (pageEvent)="onPageChange($event)"
            (changerEvent)="onChangerChange($event)"
        >
        </it-pagination>
    </div>
}
@if (!isEmbedded) {
    <it-modal #updateLinkedFolderModal="itModal" size="lg">
        <ng-container modalTitle
            ><span class="material-symbols-outlined fs-2 me-2"> new_label </span
            >{{ "it.portal.barriers.version.create" | translate }}</ng-container
        >
        <p class="pt-3">
            {{ "it.portal.barriers.update-linked-folder-message" | translate }}
        </p>
        <ng-container footer>
            <button itButton="primary" type="button" (click)="createVersion(selectedBarrier!, true)">
                {{ "it.portal.barriers.confirm-update" | translate }}
            </button>
            <button itButton="primary" type="button" (click)="createVersion(selectedBarrier!, false)">
                {{ "it.core.confirm" | translate }}
            </button>
            <button itButton="outline-primary" type="button" data-bs-dismiss="modal">
                {{ "it.general.abort" | translate }}
            </button>
        </ng-container>
    </it-modal>
}
